import { Directive, TemplateRef, inject } from "@angular/core";

@Directive({
    selector: "[appAdminModulePageToolbar]",
    standalone: false
})
export class AdminApiModulePageToolbarDirective {  tpl = inject<TemplateRef<any>>(TemplateRef);

}
